import $okgportal_api from "@/shared/client/okgportal.client";
import { BaseOkgportalResponce } from "@/shared/model/api.types";

import { 
  CompanyPlanResultDto, 
  DepartmentsResultDto,
  TopDepartmentsResult,
  TopEmployeesResult, 
  TopEmployeesDto, 
  CompanyResult,
  MyPlanResultDto,
  MyPlanResultInterface,
  UserPlanResultDto,
  DeparrtmentPlanResultDto,
  LtwCompanyResultItem,
  TopDepartmentsDto,
  TopDepartmentResultInterface, 
  DealProductsAnalytics,
  PipelineDeal,
  DepartmentPlanDeal,
} from "../model/dashboard.types";

class DashboardApi {
  async getCompanyPlanResult(data: CompanyPlanResultDto) {
    // const response = await $okgportal_api.post<BaseOkgportalResponce<CompanyResult>>('/dashboard/companyPlanResult', data);
    const response = await $okgportal_api.post<BaseOkgportalResponce<CompanyResult>>('/v2/dashboard/companyPlanResult', data);
    return response.data;
  }

  async getDepartmentsResult(data: DepartmentsResultDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<CompanyResult>>('/v2/dashboard/departmentsResults', data);
    return response.data;
  }

  async getTopEmployees(data: TopEmployeesDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<TopEmployeesResult[]>>('/v2/dashboard/topEmployees', data);
    return response.data;
  }

  async getTopDepartments(data: TopDepartmentsDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<TopDepartmentResultInterface[]>>('/v2/dashboard/topDepartments', data);
    return response.data;
  }

  async getLTWCompany(data: DeparrtmentPlanResultDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<LtwCompanyResultItem[]>>('/v2/dashboard/ltw', data);
    return response.data;
  }

  async getMyPlanResult(data: MyPlanResultDto){
    try {
      const response = await $okgportal_api.post<BaseOkgportalResponce<MyPlanResultInterface>>(`/v2/dashboard/myPlanResult`, data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async getUserPlanResult(data: UserPlanResultDto){
    try {
      const response = await $okgportal_api.post<BaseOkgportalResponce<MyPlanResultInterface>>(`/v2/dashboard/userPlanResult`, data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async getDepartmentPlanResult(data: DeparrtmentPlanResultDto){
    try {
      const response = await $okgportal_api.post<BaseOkgportalResponce<MyPlanResultInterface>>(`/dashboard/departmentPlanResult`, data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async getDepartmentPlanByEmployees(data: DeparrtmentPlanResultDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<MyPlanResultInterface>>('/dashboard/departmentPlanByEmployees', data);
    return response.data;
  }

  async getDealProductsAnalytics(dealIds: number[]) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<DealProductsAnalytics>>(
      '/v2/dashboard/dealProductsAnalytics',
      { dealIds }
    );
    return response.data;
  }


  async getPipelineDeals(data: {
    dateStart: string;
    dateEnd: string;
    scope?: 'company' | 'department' | 'employee';
    departmentId?: number;
    userId?: number;
  }) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<PipelineDeal[]>>(
      '/v2/dashboard/pipelineDeals',
      data
    );
    return response.data;
  }

  async getCompanyDeals(data: { dateStart: string; dateEnd: string }) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<DepartmentPlanDeal[]>>(
      '/v2/dashboard/companyDeals',
      data
    );
    return response.data;
  }
}

const dashboardApi = new DashboardApi();
export default dashboardApi;
